import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IDateObject } from 'src/app/analyses/interfaces/analyses.types';
import { HeartRateInstructionsModalComponent } from 'src/app/analyses/modals/heart-rate-instructions/heart-rate-instructions.modal';
import { MeasurementAddBaseDirective } from 'src/app/body-measurements/directives/measurement-add-base.directive';
import { MeasurementAddBase } from 'src/app/body-measurements/interfaces/measurement-add.interface';
import { inputPattern } from 'src/app/body-measurements/validators/pattern.validator';
import {
  ngbDateFromDate,
  subtractCurrentDateYear,
  objectToDate,
  ngbDateFromISO,
} from 'src/app/shared/util/date-util';

@Component({
  selector: 'app-measurement-add-heart-rate',
  templateUrl: './measurement-add-heart-rate.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeasurementAddHeartRateComponent
  extends MeasurementAddBaseDirective
  implements MeasurementAddBase {
  protected form = this.fb.group({
    value: ['', Validators.required],
    date: [ngbDateFromDate(new Date()), Validators.required],
  });

  protected now = ngbDateFromDate(new Date());
  protected minDate = ngbDateFromDate(subtractCurrentDateYear(10));

  constructor(private fb: FormBuilder, private modals: NgbModal) {
    super();
  }

  onSubmit() {
    if (this.form.invalid) {
      return;
    }

    const { value, date } = this.form.value;
    const generatedDate = objectToDate(
      (date as Partial<IDateObject>) ?? {}
    ).toISOString();

    return {
      measurements: [
        {
          id: this.configuration.measurementMetrics[0].id,
          unitId: this.configuration.measurementMetrics[0].units[0].id,
          value: value,
        },
      ],
      generated: generatedDate,
    };
  }

  protected updateValidators(): void {
    const unit = this.configuration.measurementMetrics[0].units[0];
    this.form.controls.value.addValidators([
      Validators.min(unit.min),
      Validators.max(unit.max),
      Validators.pattern(inputPattern(unit.decimalPlaces)),
    ]);
  }

  protected fillForm(): void {
    this.form.patchValue({
      value: String(this.analysisResult.result.results[0].result),
      date: ngbDateFromISO(this.analysisResult.result.generated),
    });
  }

  protected openModal(): void {
    this.modals.open(HeartRateInstructionsModalComponent, {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'basic-modal',
      backdropClass: 'basic-modal-backdrop',
    });
  }
}
